import { render, staticRenderFns } from "./tutoriales.vue?vue&type=template&id=27db696e&"
import script from "./tutoriales.vue?vue&type=script&lang=js&"
export * from "./tutoriales.vue?vue&type=script&lang=js&"
import style0 from "./tutoriales.vue?vue&type=style&index=0&id=27db696e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports